/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */

import React from 'react';
import { findGetParameter } from '../../controllers/utils';
import { withAuth } from '../../hooks/useAuth';

const initialState = {};

class ResetPasswordInivisible extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    // @TODO - How should we handle this now that refresh tokens are stored as secure cookies?
    // If we detect the token in the URL, should we just refresh the token? It wouldn't use the token
    // from the URL though, so not sure if this is easily refactorable at the moment.
    const refresh_token = findGetParameter('refresh_token');
    if (refresh_token) {
      const { auth } = this.props;
      auth?.refreshAccessToken().then(function (token) {
        if (token) {
          window.location.replace('/account/reset');
        }
      });
    }
  }

  render() {
    return <div />;
  }
}

export default withAuth(ResetPasswordInivisible);
